import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { Colors, Icon, Icons, Loader, LoaderSizes } from "@sellout/ui";
import * as Polished from "polished";
import { BackstageState } from "../../redux/store";
import { FadeIn, CardPop } from "@sellout/ui/build/components/Motion";

export enum ModalTypes {
  ImageCropper = "ImageCropper",
  ChangePhoneNumber = "ChangePhoneNumber",
  ChangePassword = "ChangePassword",
  ChangeEmail = "ChangeEmail",
  AddSecondaryEmail = "AddSecondaryEmail",
  TicketType = "TicketType",
  SeasonTicketType = "SeasonTicketType",
  UpgradeType = "UpgradeType",
  SeasonUpgradeType = "SeasonUpgradeType",
  Promotion = "Promotion",
  CustomField = "CustomField",
  Fee = "Fee",
  OrderDetails = "OrderDetails",
  SaveChanges = "SaveChanges",
  ConfirmAction = "ConfirmAction",
  AddRole = "AddRole",
  DeleteRole = "DeleteRole",
  ChangeRole = "ChangeRole",
  CreateVenue = "CreateVenue",
  CreateHeadliningArtist = "CreateHeadliningArtist",
  CreateOpeningArtist = "CreateOpeningArtist",
  AddTerminalDevice = "AddTerminalDevice",
  CancelEvent = "CancelEvent",
  CancelOrder = "CancelOrder",
  OrganizationInvite = "OrganizationInvite",
  PublishEvent = "PublishEvent",
  EventPublished = "EventPublished",
  Refund = "Refund",
  UserOrderTicket = "UserOrderTicket",
  SeeOrderDetailsModal = "SeeOrderDetailsModal",
  PublishSeasonModal = "PublishSeasonModal",
  SeasonPromotion = "SeasonPromotion",
  SeasonPublishedModal = "SeasonPublishedModal",
  SubscribeSalesReport = "SubscribeSalesReport",
  AdjustCheckIn = "AdjustCheckIn",
  FeeModal = "FeeModal",
  UpdateCustomer = "UpdateCustomer",
  TicketHold ="TicketHold",
  UpdateTicketBlockModal="UpdateTicketBlockModal",
  DuplicateEventModal="DuplicateEventModal",
  CreateNewOrgModal="CreateNewOrgModal",
  ConfirmationShareTicket="Share your ticket",
  AcceptShareTicket="Accept Share Ticket",
  CancelTicketSharing="Cancel ticket sharing",
  ReAttemptYcModal="YcOrderDetails",
  CheckInTicketsModal="CheckInTicketsModal",
  EmailHoldersModal="EmailHoldersModal",
  EmailHoldersPreviewModal='EmailHoldersPreviewModal',
  ImportContactModal="ImportContactModal",
  ChildSharedTicketsModal = "ChildSharedTicketsModal",
  ParentSharedByModal = "ParentSharedByModal",
  OfferedTicketModal = "OfferedTicketModal",
  UpdateSuperAdminCustomer="UpdateSuperAdminCustomer",
  DeleteSuperAdminOrg="DeleteSuperAdminOrg",
  ListEvent="ListEvent",
  ConfirmUrlStub="ConfirmUrlStub",
  ChangeEventDate="ChangeEventDate",
  TagModal="TagModal",
  AddGuestModal="AddGuestModal",
  DeleteGuestModal="DeleteGuestModal",
  CheckInGuestModal="CheckInGuestModal",
}

export const urlSafeModalTypes = {
  [ModalTypes.Promotion]: ModalTypes.Promotion,
  [ModalTypes.Fee]: ModalTypes.Fee,
  [ModalTypes.CustomField]: ModalTypes.CustomField,
  [ModalTypes.OrderDetails]: ModalTypes.OrderDetails,
};

export enum ModalPositions {
  Top = "Top",
  Center = "Center",
}

const positions = {
  [ModalTypes.ImageCropper]: ModalPositions.Top,
  [ModalTypes.ChangePhoneNumber]: ModalPositions.Top,
  [ModalTypes.ChangePassword]: ModalPositions.Top,
  [ModalTypes.ChangeEmail]: ModalPositions.Top,
  [ModalTypes.AddSecondaryEmail]: ModalPositions.Top,
  [ModalTypes.TicketType]: ModalPositions.Top,
  [ModalTypes.UpgradeType]: ModalPositions.Top,
  [ModalTypes.Promotion]: ModalPositions.Top,
  [ModalTypes.Fee]: ModalPositions.Top,
  [ModalTypes.CustomField]: ModalPositions.Top,
  [ModalTypes.OrderDetails]: ModalPositions.Top,
  [ModalTypes.SaveChanges]: ModalPositions.Top,
  [ModalTypes.ConfirmAction]: ModalPositions.Center,
  [ModalTypes.AddRole]: ModalPositions.Top,
  [ModalTypes.DeleteRole]: ModalPositions.Top,
  [ModalTypes.ChangeRole]: ModalPositions.Top,
  [ModalTypes.CreateVenue]: ModalPositions.Top,
  [ModalTypes.CreateHeadliningArtist]: ModalPositions.Top,
  [ModalTypes.CreateOpeningArtist]: ModalPositions.Top,
  [ModalTypes.AddTerminalDevice]: ModalPositions.Top,
  [ModalTypes.CancelEvent]: ModalPositions.Top,
  [ModalTypes.CancelOrder]: ModalPositions.Top,
  [ModalTypes.OrganizationInvite]: ModalPositions.Top,
  [ModalTypes.PublishEvent]: ModalPositions.Top,
  [ModalTypes.EventPublished]: ModalPositions.Top,
  [ModalTypes.Refund]: ModalPositions.Top,
  [ModalTypes.UserOrderTicket]: ModalPositions.Top,
  [ModalTypes.SubscribeSalesReport]: ModalPositions.Top,
  [ModalTypes.AdjustCheckIn]: ModalPositions.Top,
  [ModalTypes.FeeModal]: ModalPositions.Top,
  [ModalTypes.UpdateCustomer]: ModalPositions.Top,
  [ModalTypes.TicketHold]: ModalPositions.Top,
  [ModalTypes.UpdateTicketBlockModal]: ModalPositions.Top,
  [ModalTypes.DuplicateEventModal]: ModalPositions.Top,
  [ModalTypes.CreateNewOrgModal]: ModalPositions.Top,
  [ModalTypes.ConfirmationShareTicket]: ModalPositions.Top,
  [ModalTypes.AcceptShareTicket]: ModalPositions.Top,
  [ModalTypes.CancelTicketSharing]: ModalPositions.Top,
  [ModalTypes.ReAttemptYcModal]: ModalPositions.Top,
  [ModalTypes.CheckInTicketsModal]: ModalPositions.Top,
  [ModalTypes.EmailHoldersModal]: ModalPositions.Top,
  [ModalTypes.EmailHoldersPreviewModal]: ModalPositions.Top,
  [ModalTypes.ImportContactModal]: ModalPositions.Top,
  [ModalTypes.ChildSharedTicketsModal]: ModalPositions.Top,
  [ModalTypes.ParentSharedByModal]: ModalPositions.Top,
  [ModalTypes.OfferedTicketModal]: ModalPositions.Top,
  [ModalTypes.UpdateSuperAdminCustomer]: ModalPositions.Top,
  [ModalTypes.DeleteSuperAdminOrg]: ModalPositions.Top,
  [ModalTypes.ListEvent]: ModalPositions.Top,
  [ModalTypes.ConfirmUrlStub]: ModalPositions.Center,
  [ModalTypes.ChangeEventDate]: ModalPositions.Top,
  [ModalTypes.TagModal]: ModalPositions.Top,
  [ModalTypes.AddGuestModal]: ModalPositions.Top,
  [ModalTypes.DeleteGuestModal]: ModalPositions.Top,
  [ModalTypes.CheckInGuestModal]: ModalPositions.Top,
};

/********************************************************************************
 *  Modal
 *******************************************************************************/

type ContainerProps = {
  isTop: boolean;
};

const Container = styled(FadeIn)<ContainerProps>`
  position: fixed;
  height: ${(props) => (props.isTop ? "100%" : "100%")};
  width: 100%;
  background-color: ${Polished.rgba(Colors.Black, 0.4)};
  display: flex;
  justify-content: center;
  align-items: ${(props) => (props.isTop ? "flex-start" : "center")};
  padding: ${(props) => (props.isTop ? "100px 0" : "0")};
  z-index: 9999;
  overflow-y: scroll;
`;

type ModalProps = {};

const Modal: React.FC<ModalProps> = () => {
  /* State */
  const appState = useSelector((state: BackstageState) => state.app);
  const {
    modal: { modals },
  } = appState;

  /** Render */

  if (!modals.length) return null;

  const isTop =
    positions[[...modals].pop() as ModalTypes] === ModalPositions.Top;

  return (
    <Container duration={0.1} isTop={isTop}>
      {modals.map((modal, index) => {
        return (
          <RenderModal
            key={index}
            modal={modal}
            active={index === modals.length - 1}
          />
        );
      })}
    </Container>
  );
};

export default Modal;

/********************************************************************************
 *  Render Modal
 *******************************************************************************/

type RenderModalContainerProps = {
  active: boolean;
};

const RenderModalContainer = styled.div<RenderModalContainerProps>`
  position: ${(props) => (props.active ? null : "absolute")};
  top: ${(props) => (props.active ? null : "-10000000px")};
  left: ${(props) => (props.active ? null : "-10000000px")};
  @media (max-width: 767px) {
    width: 90%;
  }
`;

type RenderModalProps = {
  modal: ModalTypes;
  active: boolean;
};

const RenderModal: React.FC<RenderModalProps> = ({ modal, active }) => {
  const LazyModal = React.useMemo(() => {
    switch (modal) {
      case ModalTypes.ImageCropper:
        return React.lazy(() => import("./ImageCropperModal"));
      case ModalTypes.AddSecondaryEmail:
        return React.lazy(() => import("./AddSecondaryEmailModal"));
      case ModalTypes.ChangeEmail:
        return React.lazy(() => import("./ChangeEmailModal"));
      case ModalTypes.ChangePassword:
        return React.lazy(() => import("./ChangePasswordModal"));
      case ModalTypes.ChangePhoneNumber:
        return React.lazy(() => import("./ChangePhoneNumberModal"));
      case ModalTypes.TicketType:
        return React.lazy(() => import("../create-event/modal/CreateEventTicketTypeModal"));
      case ModalTypes.SeasonTicketType:
        return React.lazy(() => import("../create-season/modal/CreateSeasonTicketTypeModal"));
      case ModalTypes.UpgradeType:
        return React.lazy(() => import("../create-event/modal/CreateEventUpgradeTypeModal"));
      case ModalTypes.SeasonUpgradeType:
        return React.lazy(() => import("../create-season/modal/CreateSeasonUpgradeTypeModal"));
      case ModalTypes.Promotion:
        return React.lazy(() => import("../create-event/modal/CreateEventPromotionModal"));
      case ModalTypes.SeasonPromotion:
        return React.lazy(() => import("../create-season/modal/CreateSeasonPromotionModal"));
      case ModalTypes.Fee:
        return React.lazy(() => import("../create-event/modal/CreateEventFeeModal"));
      case ModalTypes.CustomField:
        return React.lazy(() => import("../create-event/modal/CreateEventCustomFieldModal"));
      case ModalTypes.SaveChanges:
        return React.lazy(() => import("./SaveChangesModal"));
      case ModalTypes.ConfirmAction:
        return React.lazy(() => import("./ConfirmActionModal"));
      case ModalTypes.AddRole:
        return React.lazy(() => import("./AddRoleModal"));
      case ModalTypes.DeleteRole:
        return React.lazy(() => import("./DeleteRoleModal"));
      case ModalTypes.ChangeRole:
        return React.lazy(() => import("./ChangeRoleModal"));
      case ModalTypes.CreateVenue:
        return React.lazy(() => import("./CreateVenueModal"));
      case ModalTypes.CreateHeadliningArtist:
        return React.lazy(() => import("./CreateHeadliningArtistModal"));
      case ModalTypes.CreateOpeningArtist:
        return React.lazy(() => import("./CreateOpeningArtistModal"));
      case ModalTypes.AddTerminalDevice:
        return React.lazy(() => import("./AddTerminalDeviceModal"));
      case ModalTypes.CancelEvent:
        return React.lazy(() => import("./CancelEventModal"));
      case ModalTypes.CancelOrder:
        return React.lazy(() => import("./CancelOrderModal"));
      case ModalTypes.OrganizationInvite:
        return React.lazy(() => import("./OrganizationInviteModal"));
      case ModalTypes.OrderDetails:
        return React.lazy(() => import("./OrderDetailsModal"));
      case ModalTypes.PublishEvent:
        return React.lazy(() => import("./PublishEventModal"));
      case ModalTypes.EventPublished:
        return React.lazy(() => import("./EventPublishedModal"));
      case ModalTypes.Refund:
        return React.lazy(() => import("./RefundModal"));
      case ModalTypes.UserOrderTicket:
        return React.lazy(() => import("./UserOrderTicketModal"));
      case ModalTypes.SeeOrderDetailsModal:
        return React.lazy(() => import("./SeeOrderDetailsModal"));
      case ModalTypes.PublishSeasonModal:
        return React.lazy(() => import("./PublishSeasonModal"));
      case ModalTypes.SeasonPublishedModal:
        return React.lazy(() => import("./SeasonPublishedModal"));
      case ModalTypes.SubscribeSalesReport:
        return React.lazy(() => import("./SubscribeSalesReportModal"));
      case ModalTypes.AdjustCheckIn:
        return React.lazy(() => import("./AdjustCheckInModal"));
      case ModalTypes.FeeModal:
        return React.lazy(() => import("./FeeModal"));
      case ModalTypes.UpdateCustomer:
        return React.lazy(() => import("./UpdateCustomerModal"));
      case ModalTypes.TicketHold:
        return React.lazy(() => import("./AddTicketBlockModal"));
      case ModalTypes.UpdateTicketBlockModal:
        return React.lazy(() => import("./UpdateTicketBlockModal"));
      case ModalTypes.DuplicateEventModal:
        return React.lazy(() => import("./DuplicateEventModal"));
      case ModalTypes.CreateNewOrgModal:
        return React.lazy(() => import("./CreateNewOrgModal"));
      case ModalTypes.ConfirmationShareTicket:
        return React.lazy(() => import("./ShareTicketConfirmationModal"));
      case ModalTypes.AcceptShareTicket:
        return React.lazy(() => import("./AcceptShareTicketModal"));
      case ModalTypes.CancelTicketSharing:
        return React.lazy(() => import("./CancelSharingTicketModal"));
      case ModalTypes.ReAttemptYcModal:
        return React.lazy(() => import("./YcOrderDetails"));
      case ModalTypes.CheckInTicketsModal:
        return React.lazy(() => import("./CheckInTicketModal"));
      case ModalTypes.EmailHoldersModal:
        return React.lazy(() => import("./EmailHoldersModal"));
      case ModalTypes.EmailHoldersPreviewModal:
        return React.lazy(() => import("./EmailHoldersPreviewModal"));
      case ModalTypes.ImportContactModal:
        return React.lazy(() => import("./ImportContactModal"));
      case ModalTypes.ChildSharedTicketsModal:
        return React.lazy(() => import("./ChildSharedTicketsModal").then(module => ({ default: module.ChildSharedTicketsModal })));
      case ModalTypes.ParentSharedByModal:
        return React.lazy(() => import("./ParentSharedByModal").then(module => ({ default: module.ParentSharedByModal })));
        case ModalTypes.OfferedTicketModal:
        return React.lazy(() => import("./OfferedTicketModal").then(module => ({ default: module.OfferedTicketModal })));
      case ModalTypes.UpdateSuperAdminCustomer:
        return React.lazy(() => import("./UpdateSuperAdminCustomer"));
      case ModalTypes.DeleteSuperAdminOrg:
        return React.lazy(() => import("./DeleteSuperAdminOrg"));
      case ModalTypes.ListEvent:
        return React.lazy(() => import("./ListEventModal"));
      case ModalTypes.ConfirmUrlStub:
        return React.lazy(() => import("./ConfirmUrlStubModal"));
      case ModalTypes.ChangeEventDate:
        return React.lazy(() => import("./ChangeEventDateModal"));
      case ModalTypes.TagModal:
        return React.lazy(() => import("./TagModal"));
      case ModalTypes.AddGuestModal:
        return React.lazy(() => import("./AddGuestModal"));
      case ModalTypes.DeleteGuestModal:
        return React.lazy(() => import("./DeleteGuestModal"));
      case ModalTypes.CheckInGuestModal:
        return React.lazy(() => import("./CheckInGuestModal"));
      default:
        return null;
    }
  }, [modal]);

  return (
    <RenderModalContainer active={active}>
      <React.Suspense fallback={<Loader size={LoaderSizes.Large} color={Colors.Orange} />}>
        {LazyModal && <LazyModal />}
      </React.Suspense>
    </RenderModalContainer>
  );
};

/********************************************************************************
 *  Exported Modal Styles - for use in modal implmentations
 *******************************************************************************/

type ModalContainerProps = {
  height?: string;
  width?: string;
  display?: string;
  position?: string;
  top?: string;
  left?: string;
};

export const ModalContainer = styled(CardPop)<ModalContainerProps>`
  position: ${(props) => props.position || "relative"};
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  border-radius: 10px;
  background-color: ${Colors.OffWhite};
  overflow: visible;
  display: ${(props) => props.display};
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  @media (max-width: 991px) {
    width: 100%;
    margin: 0 auto;
  }
`;

const ModalHeaderContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 49px;
  padding: 0 20px;
  border-radius: 10px 10px 0px 0px;
  background-color: ${Colors.White};
  border-bottom: 1px solid ${Colors.Grey6};
`;

const ModalTitle = styled.div`
  font-size: 1.4rem;
  font-weight: 600;
  color: ${Colors.Grey1};
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

type ModalHeaderProps = {
  title: string;
  icon?: any;
  close: Function;
};

export const ModalHeader: React.FC<ModalHeaderProps> = ({
  title,
  icon,
  close,
}) => {
  return (
    <ModalHeaderContainer>
      <Row>
        {icon && icon}
        <ModalTitle>{title}</ModalTitle>
      </Row>
      <Icon
        icon={Icons.CancelCircle}
        color={Colors.Grey5}
        hoverColor={Colors.Red}
        size={14}
        onClick={close}
      />
    </ModalHeaderContainer>
  );
};

type ModalContentHeight = {
  height?: string;
  padding?: string;
  backgroundColor?: string;
};

export const ModalContent = styled.div<ModalContentHeight>`
  position: relative;
  padding: ${(props) => props.padding || "20px"};
  height: ${(props) => props.height};
  background-color: ${(props) => props.backgroundColor};
`;

export const ModalFooter = styled.div<ModalContentHeight>`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${(props) => (props.padding ? props.padding : "9px 20px")};
  background-color: ${Colors.White};
  border-top: 1px solid ${Colors.Grey6};
  border-radius: 0px 0px 10px 10px;
`;
